export interface IIndexQuery {
    waitForNonStaleResultsTimeout: number;
}
